export default "__VITE_ASSET__BD$47a8C__"